import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { LogoModule } from '../logo/logo.module';

export interface RegionRestrictionDialogData {
  headerImage?: string;
  title: string;
  message: string | string[];
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  closeOnCancel?: boolean; // 控制點擊取消按鈕後是否關閉彈窗，預設為true
}

@Component({
  selector: 'app-region-restriction-dialog',
  standalone: true,
  imports: [CSButtonComponent, LogoModule],
  templateUrl: './region-restriction-dialog.component.html',
  styleUrl: './region-restriction-dialog.component.scss',
})
export class RegionRestrictionDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<RegionRestrictionDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: RegionRestrictionDialogData,
  ) {}

  /**
   * 檢查訊息是否為陣列
   */
  isMessageArray(): boolean {
    return Array.isArray(this.data.message);
  }

  /**
   * 獲取訊息陣列
   */
  getMessageArray(): string[] {
    if (this.isMessageArray()) {
      return this.data.message as string[];
    }
    return [this.data.message as string];
  }

  /**
   * 關閉彈窗
   */
  close(): void {
    this.dialogRef.close();
  }

  /**
   * 確認按鈕點擊
   */
  onConfirm(): void {
    if (this.data.onConfirm) {
      this.data.onConfirm();
    }
    this.close();
  }

  /**
   * 取消按鈕點擊
   */
  onCancel(): void {
    if (this.data.onCancel) {
      this.data.onCancel();
    }
    // 只有當 closeOnCancel 為 true（或未設定，預設為 true）時才關閉彈窗
    if (this.data.closeOnCancel !== false) {
      this.close();
    }
  }
}
